module.exports = __webpack_public_path__ + "img/watcher.834c71b6.svg";